/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class DataNotAvailableIcon extends BaseIcon {
    getChildren = () => [
        <path fill="none" strokeLinecap="round" strokeMiterlimit={10} stroke={this.getColor()} className="cls-1" d="M6 13.47h14M6 17.47h12M6 21.47h10"/>,
        <path fill={this.getColor()} className="cls-2" d="M18 26a6 6 0 106-6 6 6 0 00-6 6z"/>,
        <path fill="none" strokeLinecap="round" strokeMiterlimit={10} stroke="#fff" className="cls-3" d="M26.57 23.43l-5.14 5.14M26.57 28.57l-5.14-5.14"/>,
        <path fill="none" strokeLinecap="round" strokeMiterlimit={10} stroke={this.getColor()} className="cls-1" d="M20 4.47h3.08a1 1 0 01.92 1v13M18 31.47H2.92a1 1 0 01-.92-1v-25a1 1 0 01.92-1H7"/>,
        <path fill={this.getColor()} className="cls-2"
              d="M13 1a1.5 1.5 0 11-1.5 1.5A1.5 1.5 0 0113 1m0-1a2.5 2.5 0 102.5 2.5A2.5 2.5 0 0013 0z" />,
        <path fill="none" strokeLinecap="round" strokeMiterlimit={10} stroke={this.getColor()} className="cls-1" d="M15 2.47h3a1 1 0 011 1v2a1 1 0 01-1 1H8a1 1 0 01-1-1v-2a1 1 0 011-1h3"/>
    ]
    getViewBox = () => '0 0 32 32'
}
